import React from 'react'
import i18n from 'i18next'
import { format, toPrice } from '@dt/fe-utils'

interface IProps {
  cardInfo: {
    isIntegral: boolean;
    money: number | null;
    mallMoney: number | null;
    isIntegralMoney: boolean;
    integralMoney: number | null;
    integralCostMoney: number | null;
    integralMoneyMaxType: string;
    integralMoneyMax: number | null;
    mallIntegralMoney: number | null;
    mallIntegralCostMoney: number | null;
    mallIntegralMoneyMaxType: string;
    mallIntegralMoneyMax: number | null;
    isIntegralClear: boolean;
    integralClearType: string;
  };
  showClearTip?: boolean;
}

const CardIntegralEquity = ({ cardInfo, showClearTip = true }: IProps) => {
  if (!cardInfo.isIntegral) return null
  return (
    <>
      {!!cardInfo.money && <div>{i18n.t('mkt.member.mealGetPoints', { amount: toPrice(cardInfo.money, 2, false) })}</div>}
      {!!cardInfo.isIntegralMoney && !!cardInfo.integralMoney && <div>{i18n.t('mkt.member.mealDeductPoints', { num: cardInfo.integralMoney, price: toPrice(cardInfo.integralCostMoney, 2, false), amount: cardInfo.integralMoneyMaxType === 'discountRate' ? `${Math.round(cardInfo.integralMoneyMax * 10000) / 100}%` : toPrice(cardInfo.integralMoneyMax) })}</div>}
      {!!cardInfo.mallMoney && <div>{i18n.t('mkt.member.mallGetPoints', { amount: toPrice(cardInfo.mallMoney, 2, false) })}</div>}
      {!!cardInfo.isIntegralMoney && !!cardInfo.mallIntegralMoney && <div>{i18n.t('mkt.member.mallDeductPoints', { num: cardInfo.mallIntegralMoney, price: toPrice(cardInfo.mallIntegralCostMoney, 2, false), amount: cardInfo.mallIntegralMoneyMaxType === 'discountRate' ? `${Math.round(cardInfo.mallIntegralMoneyMax * 10000) / 100}%` : toPrice(cardInfo.mallIntegralMoneyMax) })}</div>}
      {showClearTip && !!cardInfo.isIntegralClear && (
        <div>
          {cardInfo.integralClearType === 'twoYear' && i18n.t('mkt.member.clearPointsType2')}
          {cardInfo.integralClearType === 'oneYear' && i18n.t('mkt.member.clearPointsType1')}
          {cardInfo.integralClearType === 'halfYear' && i18n.t('mkt.member.clearPointsType3')}
        </div>
      )}
    </>
  )
}

export default CardIntegralEquity
